<script>
export default {
  created() {
  },
  props: {
      codeEvent: {
         type: Function
      },
      searchEvent: {
          type: Function
      },
      codeDetail: {
          type: Object
      },
      selectOption: {
          type: Object
      },
      dialogOption: {
          type: Object
      }
  },
  data() {
      return {
          query: {
              id: '',
              password: '',
              company: '',
              vip: '',
              vipExpireTime: '',
              status: ''
          }
      }
  },
  methods: {
      base64(str, type) {
            const base = new this.$Base64();
            return base[type](str);
      },
      modelStatus(val) {
          this.dialogOption.show = val;
          this.initQuery();
      },
      initQuery() {
          this.$refs.user.clearValidate();
          switch(+this.dialogOption.type) {
              case 0:
                  this.$clearObject(this.query);
                  break;
              case 1:
                  this.$setObject(this.query,this.codeDetail);
                  this.query.password = this.base64(this.codeDetail.password, 'decode');
                  console.log(this.query);
                  break;
              case 2:
                  this.$setObject(this.authQuery,this.codeDetail);
                  break;
          }
      },
      async submit() {
        const {type} = this.dialogOption;
        // const {code} = await this.codeEvent({
        //     ...this.query,
        //     password: this.base64(this.query.password, 'encode')
        // });
        const {code} = await this.codeEvent(this.query);
        if (Object.is(code, 200)) {
            this.searchEvent();
            this.$message.success(`${this.dialogOption.title}成功`);
        }
        this.dialogOption.show = false;
        this.$clearObject(this.query);
      },
      submitForm(formName) {
           this.$refs[formName].validate((valid) => {
           valid && this.submit();
        });
      }
  },
  mounted() {
  },
  computed: {
  },
  watch: {
      codeDetail(val) {
          this.$setObject(this.query, val);
      }
  }
}
</script>
<template>
<div class="edit">
  <el-dialog
    :title="dialogOption.title"
    :width="dialogOption.width"
    :visible.sync="dialogOption.show"
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <el-form :model="query" ref="user">
        <el-form-item label="用户密码" label-width="100px" prop="password"
          :rules="[{required: true, message: '不能为空', trigger: 'change'}]"
         >
          <el-input  v-model="query.password"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" label-width="100px" prop="company"
          :rules="[{required: true, message: '不能为空', trigger: 'change'}]"
        >
            <el-input type="textarea" row="3" v-model="query.company"></el-input>
        </el-form-item>
        <el-form-item label="vip状态" label-width="100px" prop="vip"
          :rules="[{required: true, message: '不能为空', trigger: 'change'}]">
            <el-select v-model="query.vip" class="common-width"
                placeholder="vip状态"
                >
                    <el-option
                        v-for="item in selectOption.vip"
                        :key="item.key"
                        :label="item.typeName"
                        :value="item.key"
                    >
                    </el-option>
                </el-select>
        </el-form-item>
        <el-form-item label="vip过期时间" label-width="100px" prop="vipExpireTime"
          :rules="[{required: true, message: '不能为空', trigger: 'change'}]"
        >
            <el-date-picker class="common-width"
                v-model="query.vipExpireTime"
                type="datetime"
                placeholder="vip过期时间"
				value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
        </el-form-item>
        <el-form-item label="用户状态" label-width="100px" prop="status"
          :rules="[{required: true, message: '不能为空', trigger: 'change'}]"
        >
            <el-select v-model="query.status" class="common-width"
                placeholder="用户状态"
                >
                    <el-option
                        v-for="item in selectOption.status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
          <el-button @click="dialogOption.show = false" size="small">取消</el-button>
          <el-button type="success"
            @click="submitForm('user')" size="small">提交</el-button>
    </div>
</el-dialog>
</div>
</template>
<style scoped lang="stylus">


</style>
